export function scrollToTop(smooth?: boolean) {
  window.scrollTo({ behavior: smooth ? "smooth" : undefined, top: 0, left: 0 });
}
